/** A non-2xx answer from the API: the status and its safe `{ error }` message. */
export class HttpError extends Error {
    status;
    error;
    constructor(status, error) {
        super(`API ${status}: ${error}`);
        this.status = status;
        this.error = error;
    }
}
/** Why a call never got an answer: it ran out of time, or the phone had no network. */
export const NetReason = { timeout: "timeout", offline: "offline" };
/** A call that got no answer from the API at all (as opposed to an error answer, which is an HttpError). */
export class NetError extends Error {
    reason;
    constructor(reason) {
        super(`API unreachable: ${reason}`);
        this.reason = reason;
    }
}
//# sourceMappingURL=errors.js.map